import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { MatDialog } from '@angular/material';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInDown } from 'ng-animate';

@Component({
  selector: 'hybse-admin-add-invitation',
  templateUrl: './add-invitation.component.html',
  styleUrls: ['./add-invitation.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation( fadeInDown,{
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class AddInvitationComponent implements OnInit {

  constructor(private _fb:FormBuilder,
    private _req:ApirequestService,
    private _urls:ApiurlsService,
    private dialog: MatDialog,
    private _utils:UtilityService,
    public route : ActivatedRoute,
    private router: Router ) { }
    createInvitationForm:FormGroup;
    formTitle:string = 'Add New User';
  formResponseMsg:string = '';
  alertStatusMessage:boolean;
  showLoader:boolean = false;
  formSubmitted:boolean = false;
  fadeInDown:any;
    createInvitationFormInit() {
      this.createInvitationForm = this._fb.group({
        'email': ['',[Validators.required]]
      });
    }
    createUpdateInvitation(form)
    {
      let formVal = this.createInvitationForm.value;
    this.formSubmitted = true;
    let seed = this;
    if(this.createInvitationForm.valid) {
      this.showLoader = true;
      let data:any = {
          invity: formVal.email
      };
      let url = '';
url = this._urls.createInvitationUrl;      
      this._req.fetchApiData(url,data).subscribe(
        (data:any) => {
          let response = data.data;
          let responseErr = data.error;
          this.showLoader = false;
          this.formSubmitted = false;
          this._utils.scrollToY(0,400,'easeInOutQuint');
          if(response != '') {
            this.formResponseMsg = 'Invitation has been sent Successfully';
            this.alertStatusMessage = true;
            setTimeout(()=>{
              this.router.navigate(['/invitation/list'])
            },2000);
          }
          if(responseErr != '') {
            this.formResponseMsg = responseErr['Error Msg'];
            this.alertStatusMessage = false;
          }
        },
        error => {

        },
        () => {

        }
      );

    }
    }
    cancelInvitationCreate()
    {
      this.router.navigate(['/invitation/list']);
    }
  ngOnInit() {
    this.createInvitationFormInit();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/invitation/add-invitation/add-invitation.component.ts